import React from 'react';
import PropTypes from 'prop-types';
import ThinkingOrb from '../ThinkingOrb/ThinkingOrb';
import './Loading.scss';

const Loading = ({ name = 'Запуск системы...' }) => (
  <div className="loading-overlay">
    <div className="loading-glass-card">
      <ThinkingOrb size="lg" text={name} />
    </div>
  </div>
);

Loading.propTypes = {
  name: PropTypes.string,
};

export default Loading;